<mat-expansion-panel [expanded]="false"
                     *ngIf="(hasRole(rolesDarEnum.gestionnaire) | async) || (hasRole(rolesDarEnum.admin) | async)"
                     style="background-color: #edb696">
  <mat-expansion-panel-header>
    <strong>{{getTitleDemandeur('title')}}</strong>
  </mat-expansion-panel-header>
  <mat-panel-description>
    {{getTitleDemandeur('description')}}
  </mat-panel-description>
  <mat-card-content fxLayout="column">
    <form fxLayout="column">
      <app-search-ldap fxFlex="70" [ldapDisplayProperty]="'cn,mail'"
                       [removeDiatrics]="true"
                       [titleLabel]="'Remplacement du demandeur'"
                       [placeHolder]="'Rechercher une personne dans l\'annuaire puis la sélectionner pour l\'ajouter...'"
                       [scope]="true"
                       [title]="false"
                       [defaultScopes]="'employee'"
                       [scopesToDisplay]="['employee', 'faculty', 'researcher']"
                       (ldapUserSelected)="onSelectNewDemandeur($event)">
      </app-search-ldap>
    </form>
  </mat-card-content>
</mat-expansion-panel>
